export default class BookCreeperLayer {
    constructor(creeper) {
        this.type = 'book_creeper';
        this.creeper = creeper;
    }
}
